/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.conglomerateMemberships.internal

import features.conglomerateMemberships.models.Businesses
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.conglomerateMemberships.internal.ConglomerateMembershipsUseCase.Params

internal class ConglomerateMembershipsUseCase : AsyncUseCase<Businesses, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,

    )

    private val conglomerateMembershipsService: ConglomerateMembershipsService = ConglomerateMembershipsServiceImpl()

    override suspend fun run(params: Params): Result<Businesses> {
        return conglomerateMembershipsService.getConglomerateMemberships(
            overrideHeaders = params.overrideHeaders,

        )
    }
}
